import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import { MarketingContactForm, ContactFormData } from "./MarketingContactForm";

/**
 * Container for MarketingContactForm.
 * Handles API submission.
 */
export function MarketingContactFormContainer() {
  const submitForm = useMutation({
    mutationFn: async (data: ContactFormData) => {
      return await apiRequest(
        "/marketing/contact/",
        "POST",
        {
          first_name: data.firstName,
          last_name: data.lastName,
          ...data,
          form_type: "contact",
        },
        false
      );
    },
  });

  return (
    <MarketingContactForm onSubmit={submitForm.mutateAsync} className="max-w-sm" />
  );
}

export default MarketingContactFormContainer;

